.content-container {
    display: flex;
    width: 100%;
    gap: 8px;
    box-sizing: border-box;
    margin-bottom: 8px;
}
